import { useState, useEffect } from 'react';
import {
  Box,
  Switch,
  FormControlLabel,
  TablePagination,
  TablePaginationProps,
  tablePaginationClasses,
} from '@mui/material';
import { Theme, SxProps } from '@mui/material/styles';

type Props = {
  dense?: boolean;
  onChangeDense?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  sx?: SxProps<Theme>;
};

export default function CasTablePagination({
  dense,
  onChangeDense,
  rowsPerPageOptions: parmRowsPerPageOptions = [5, 10, 20],
  rowsPerPage,
  sx,
  ...other
}: Props & TablePaginationProps) {
  const [rowsPerPageOptions, setRowsPerPageOptions] = useState(parmRowsPerPageOptions);

  useEffect(() => {
    setRowsPerPageOptions((prevOptions) => {
      if (prevOptions.includes(rowsPerPage)) return prevOptions;
      return [...prevOptions, rowsPerPage].sort((a: any, b: any) => a - b);
    });
  }, [rowsPerPage]);

  return (
    <Box sx={{ position: 'relative', ...sx }}>
      <TablePagination
        rowsPerPageOptions={rowsPerPageOptions}
        rowsPerPage={rowsPerPage}
        component="div"
        {...other}
        sx={{
          borderTopColor: 'transparent',
          // TablePagination's row is a MuiToolbar, so it inherits the header's yellow underline and
          // 3px bottom padding from layout.scss. Drop both, and trim the theme's 64px row so the
          // text keeps its top spacing but sits 8px (not 22px) above the bottom edge.
          [`& .${tablePaginationClasses.toolbar}`]: {
            borderBottom: 'none',
            height: 49,
            minHeight: 0,
            pt: '11px',
            pb: 0,
          },
        }}
      />

      {onChangeDense && (
        <FormControlLabel
          label="Dense"
          control={<Switch checked={dense} onChange={onChangeDense} />}
          sx={{
            pl: 2,
            py: 1.5,
            top: 0,
            position: {
              sm: 'absolute',
            },
          }}
        />
      )}
    </Box>
  );
}
